"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStatusAlertName = exports.DAYS_CURRENT_BEFORE_DQ_UNBLOCK = void 0;
/**
 * Require account to wait 10 days AFTER the cure day (so total 11 days from cure day).
 */
exports.DAYS_CURRENT_BEFORE_DQ_UNBLOCK = 11;
/**
 * Enum for account status alert names used in the AccountStatusBanner.vue component
 */
var AccountStatusAlertName;
(function (AccountStatusAlertName) {
    AccountStatusAlertName["delinquent"] = "delinquent";
    AccountStatusAlertName["pastDue"] = "pastDue";
    AccountStatusAlertName["overLimit"] = "overLimit";
    AccountStatusAlertName["fraud"] = "fraud";
    AccountStatusAlertName["blocked"] = "blocked";
    AccountStatusAlertName["closed"] = "closed";
    AccountStatusAlertName["pendingClose"] = "pendingClose";
    /** @deprecated, we no longer offer limited mode */
    AccountStatusAlertName["pendingPayoffThenLimitedMode"] = "pendingPayoffThenLimitedMode";
    AccountStatusAlertName["limitedMode"] = "limitedMode";
    AccountStatusAlertName["homeReAttachInProgress"] = "homeReAttachInProgress";
    AccountStatusAlertName["homeReAttachInRescission"] = "homeReAttachInRescission";
    AccountStatusAlertName["expiringFloodInsurance"] = "expiringFloodInsurance";
    AccountStatusAlertName["expiredFloodInsurance"] = "expiredFloodInsurance";
    AccountStatusAlertName["paymentProcessingAfterPastDue"] = "paymentProcessingAfterPastDue";
    AccountStatusAlertName["megaphone"] = "megaphone";
    AccountStatusAlertName["suspiciousPaymentFraud"] = "suspiciousPaymentFraud";
    AccountStatusAlertName["digitalWalletSecurity"] = "digitalWalletSecurity";
    AccountStatusAlertName["inAppPaymentsBlocked"] = "inAppPaymentsBlocked";
    AccountStatusAlertName["multiplePaymentReversals"] = "multiplePaymentReversals";
    AccountStatusAlertName["earlyRiskyReversal"] = "earlyRiskyReversal";
    AccountStatusAlertName["renewalReservesVerificationAFCFullBlock"] = "renewalReservesVerificationAFCFullBlock";
    AccountStatusAlertName["renewalReservesVerificationAFCPartialBlock"] = "renewalReservesVerificationAFCPartialBlock";
    AccountStatusAlertName["ninetyDaysPastDue"] = "ninetyDaysPastDue";
    AccountStatusAlertName["signedHardshipReliefOfferNotExecuted"] = "signedHardshipReliefOfferNotExecuted";
    AccountStatusAlertName["missingRequiredHomeownerInsurance"] = "missingRequiredHomeownerInsurance";
})(AccountStatusAlertName || (exports.AccountStatusAlertName = AccountStatusAlertName = {}));
